import { map as Rmap } from "ramda";
import { InventoryLot, buildNewInventoryLot } from "@/models/InventoryLot";
import { AcInventoryLotResult } from "@/components/Autocomplete/ac-inventory-lot";

interface InventoryLotState {
  inventoryLots: InventoryLot[];
  inventoryLot: InventoryLot;
}

const state: InventoryLotState = {
  inventoryLots: [],
  inventoryLot: buildNewInventoryLot(),
};

const mutations = {
  LOAD_INVENTORY_LOTS(state: InventoryLotState, payload: InventoryLot[]) {
    state.inventoryLots = payload;
  },
  LOAD_INVENTORY_LOT(state: InventoryLotState, payload: InventoryLot) {
    state.inventoryLot = payload;
  },
};

const actions = {
  loadInventoryLots(context: any, inventoryLots: InventoryLot[]) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_INVENTORY_LOTS", inventoryLots);
      resolve(inventoryLots);
    });
  },

  loadInventoryLot(context: any, inventoryLot: InventoryLot) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_INVENTORY_LOT", inventoryLot);
      resolve(inventoryLot);
    });
  },
};

const getters = {
  inventoryLots: (state: InventoryLotState) => {
    return state.inventoryLots;
  },
  inventoryLot: (state: InventoryLotState) => {
    return state.inventoryLot;
  },
  inventoryLotsForAutocompleteId: (
    state: InventoryLotState,
  ): AcInventoryLotResult[] => {
    // map over the items and just return a label and an id
    return Rmap(inventoryLot => {
      return {
        id: inventoryLot.id,
        label: inventoryLot.label,
        clientLabel: inventoryLot.client_label,
        commodityLabel: inventoryLot.commodity_label,
        defaultSellPrice: inventoryLot.default_sell_price,
        lotUnitLabel: inventoryLot.lot_unit_label,
        lotUnitId: inventoryLot.lot_unit_id,
      };
    }, state.inventoryLots);
  },
};

const inventoryLotsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default inventoryLotsModule;
